export default __webpack_public_path__ + "static/media/not-found.3eb42a14.jpg";